import { useState, useEffect } from "react";
import { BrowserRouter } from 'react-router-dom';


/* ================= PROVIDERS ================= */
import { AlarmProvider } from "./context/AlarmContext";
import { WellProvider } from "./context/WellContext";
import { AirCoolerProvider } from "./context/AirCoolerContext";
import { PumpProvider } from "./context/PumpContext";
import { TransformerProvider } from "./context/TransformerContext";
import { TrendProvider } from "./context/TrendContext";
import { PigProvider } from "./components/PigEngine";
import { ProcessProvider } from "./context/ProcessContext";
import { EquipmentProvider } from "./context/EquipmentContext";
import { AuthProvider } from "./context/AuthContext";


/* ================= FLOATING LAYER ================= */
import PinnedTransmittersLayer from "./components/PinnedTransmittersLayer";

/* ================= LAYOUT ================= */
import TopBar from "./layout/TopBar";
import BottomNav from "./layout/BottomNav";

/* ================= HOME ================= */
import HomePage from "./pages/HomePage";

/* ================= REFINERY PAGES ================= */
import MarineTerminal from "./pages/MarineTerminal";
import PipelineReceiving from "./pages/PipelineReceiving";
import TruckOffloading from "./pages/TruckOffloading";

import CrudeTank1 from "./pages/CrudeTank1";
import CrudeTank2 from "./pages/CrudeTank2";
import SlopTank from "./pages/SlopTank";
import BlendingSystem from "./pages/BlendingSystem";
import DayTank from "./pages/DayTank";

import PigLauncher from "./pages/PigLauncher";
import PigReceiver from "./pages/PigReceiver";

import PreHeatTrain1 from "./pages/PreHeatTrain1";
import PreHeatTrain2 from "./pages/PreHeatTrain2";

import Desalter1 from "./pages/Desalter1";
import Desalter2 from "./pages/Desalter2";
import PostDesalterHEX1 from "./pages/PostDesalterHEX1";
import PostDesalterHEX2 from "./pages/PostDesalterHEX2";

import PreFlashTower from "./pages/PreFlashTower";
import PFRefluxCond1 from "./pages/PFRefluxCond1";
import PFRefluxCond2 from "./pages/PFRefluxCond2";
import FurnacePreHeat from "./pages/FurnacePreHeat";
import Furnace from "./pages/Furnace";

import MainFractionationTowers from "./pages/MainFractionationTowers";
import MainFractionationTowers2 from "./pages/MainFractionationTowers2";

import T102RefluxCond from "./pages/T102RefluxCond";
import NaphthaReflux from "./pages/NaphthaReflux";
import ProductStripper from "./pages/ProductStripper";
import SurgeTank from "./pages/SurgeTank";
import StabilizationTower from "./pages/StabilizationTower";
import StabilizationReflux from "./pages/StabilizationReflux";

import CorrosionDosing from "./pages/CorrosionDosing";

import FuelGasSystem from "./pages/FuelGasSystem";
import DieselCooler from "./pages/DieselCooler";
import Residue from "./pages/Residue";
import Naphtha from "./pages/Naphtha";
import LPG from "./pages/LPG";
import Diesel from "./pages/Diesel";
import Kerosene from "./pages/Kerosene";
import LoadingGantry from "./pages/LoadingGantry";
import Desalination from "./pages/Desalination";
import Flare from "./pages/Flare";
import EconometricDashboard from "./pages/EconometricDashboard";
import LoginPage from "./pages/LoginPage";




/* ================= SECURITY LOCK ================= */
function SecurityLock() {
  useEffect(() => {
    const blockContextMenu = (e) => e.preventDefault();
    const blockKeys = (e) => {
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.shiftKey && e.key === "J") ||
        (e.ctrlKey && e.key === "U") ||
        (e.ctrlKey && e.key === "S") ||
        (e.ctrlKey && e.key === "C")
      ) {
        e.preventDefault();
      }
    };
    window.addEventListener("contextmenu", blockContextMenu);
    window.addEventListener("keydown", blockKeys);
    return () => {
      window.removeEventListener("contextmenu", blockContextMenu);
      window.removeEventListener("keydown", blockKeys);
    };
  }, []);
  return null;
}

/* ================= LAYOUT ================= */
function Layout() {
  const [page, setPage] = useState("HomePage");
  const isHome = page === "HomePage";
  const isLogin = page === "LoginPage";
  const isEconometricDashboard = page === "EconometricDashboard";




  return (
    <>
      <SecurityLock />

      {/* ✅ Only show TopBar when NOT on HomePage or LoginPage */}
      {!isHome && !isLogin && !isEconometricDashboard && (
        <TopBar
          title="30,000 BPD Modular Refinery DCS System"
          setPage={setPage}
        />
      )}

      <div
        style={{
          paddingTop:

            isEconometricDashboard
              ? "0px"
              :
              (isHome || isLogin)
                ? "0px"
                :
                "60px",


          paddingBottom:

            isEconometricDashboard
              ? "0px"
              :
              (isHome || isLogin)
                ? "0px"
                :
                "200px"
        }}
      >
        {/* ================= ✅ HOME ================= */}
        {page === "HomePage" && <HomePage setPage={setPage} />}

        {/* ================= ✅ LOGIN ================= */}
        {page === "LoginPage" && <LoginPage setPage={setPage} />}

        {/* ================= ✅ CRUDE RECEIVING ================= */}
        {page === "MarineTerminal" && <MarineTerminal />}
        {page === "PipelineReceiving" && <PipelineReceiving />}
        {page === "TruckOffloading" && <TruckOffloading />}

        {/* ================= ✅ TANK FARM ================= */}
        {page === "CrudeTank1" && <CrudeTank1 />}
        {page === "CrudeTank2" && <CrudeTank2 />}
        {page === "SlopTank" && <SlopTank />}
        {page === "BlendingSystem" && <BlendingSystem />}
        {page === "DayTank" && <DayTank />}

        {/* ================= ✅ PIGGING ================= */}
        {page === "PigLauncher" && <PigLauncher />}
        {page === "PigReceiver" && <PigReceiver />}

        {/* ================= ✅ PREHEAT ================= */}
        {page === "PreHeatTrain1" && <PreHeatTrain1 />}
        {page === "PreHeatTrain2" && <PreHeatTrain2 />}

        {/* ================= ✅ DESALTER ================= */}
        {page === "Desalter1" && <Desalter1 />}
        {page === "Desalter2" && <Desalter2 />}

        {/* ================= ✅ POST DESALTER ================= */}
        {page === "PostDesalterHEX1" && <PostDesalterHEX1 />}
        {page === "PostDesalterHEX2" && <PostDesalterHEX2 />}

        {/* ================= ✅ CDU FRONT END ================= */}
        {page === "PreFlashTower" && <PreFlashTower />}
        {page === "PFRefluxCond1" && <PFRefluxCond1 />}
        {page === "PFRefluxCond2" && <PFRefluxCond2 />}
        {page === "FurnacePreHeat" && <FurnacePreHeat />}
        {page === "Furnace" && <Furnace />}

        {/* ================= ✅ FRACTIONATION ================= */}
        {page === "MainFractionationTowers" && <MainFractionationTowers />}
        {page === "MainFractionationTowers2" && <MainFractionationTowers2 />}

        {/* ================= ✅ PRODUCTS ================= */}
        {page === "T102RefluxCond" && <T102RefluxCond />}
        {page === "NaphthaReflux" && <NaphthaReflux />}
        {page === "ProductStripper" && <ProductStripper />}
        {page === "SurgeTank" && <SurgeTank />}
        {page === "StabilizationTower" && <StabilizationTower />}
        {page === "StabilizationReflux" && <StabilizationReflux />}

        {/* ================= ✅ DOSING ================= */}
        {page === "CorrosionDosing" && <CorrosionDosing />}

        {/* ================= ✅ UTILITIES ================= */}
        {page === "FuelGasSystem" && <FuelGasSystem />}
        {page === "DieselCooler" && <DieselCooler />}
        {page === "Residue" && <Residue />}
        {page === "Naphtha" && <Naphtha />}
        {page === "LPG" && <LPG />}
        {page === "Diesel" && <Diesel />}
        {page === "Kerosene" && <Kerosene />}
        {page === "LoadingGantry" && <LoadingGantry />}
        {page === "Desalination" && <Desalination />}
        {page === "Flare" && <Flare />}
        {page === "EconometricDashboard" && <EconometricDashboard setPage={setPage} />}
      </div>

      {/* ✅ Only show BottomNav when NOT on HomePage or LoginPage */}
      {!isHome && !isLogin && (
        <BottomNav setPage={setPage} currentPage={page}  />
      )}

      <PinnedTransmittersLayer />
    </>
  );
}

/* ================= APP ================= */
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <EquipmentProvider>
          <PigProvider>
            <TrendProvider>
              <TransformerProvider>
                <WellProvider>
                  <AlarmProvider>
                    <AirCoolerProvider>
                      <PumpProvider>
                        <ProcessProvider>
                          <Layout />
                        </ProcessProvider>
                      </PumpProvider>
                    </AirCoolerProvider>
                  </AlarmProvider>
                </WellProvider>
              </TransformerProvider>
            </TrendProvider>
          </PigProvider>
        </EquipmentProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;